import axios from 'axios'
import Vue from 'vue'

let baseURL = process.env.VUE_APP_SERVER + process.env.VUE_APP_API_ENDPOINT
let githubOAuthBaseURL = process.env.VUE_APP_SERVER + process.env.VUE_APP_GH_OAUTH_ENDPOINT

const apiAxiosInstance = axios.create({ baseURL })
const githubOAuthAxiosInstance = axios.create({ baseURL: githubOAuthBaseURL })

apiAxiosInstance.interceptors.response.use((res) => res.data)

apiAxiosInstance.interceptors.request.use(async (config) => {
  const authService = Vue.prototype.$auth

  let token
  if (authService.user) {
    let account = authService.msalClient.getAccountByHomeId(authService.user.homeAccountId)
    let request = {
      account,
      scopes: [process.env.VUE_APP_SCOPE]
    }
    try {
      token = await authService.msalClient.acquireTokenSilent(request)
    } catch (err) {
      console.error(err)
    }
  }
  config.headers['Authorization'] = `Bearer ${token.accessToken}`
  return config
})

export { apiAxiosInstance, githubOAuthAxiosInstance }
